<template>
  <b-row>
    <b-col v-if="isLoading">
      <Loader size="lg"></Loader>
    </b-col>
    <b-col v-else>
      <b-row>
        <b-col>
          <div class="mb-1 float-left">
            <button v-if="ableToCreateInvoice" type="button" class="btn btn-sm btn-success" @click="generateInvoice()">{{ $t('buttons.createInvoice') }}</button>
            <router-link
              v-else-if="ableToViewInvoice"
              tag="button"
              :to="{ name: 'EXSBInvoiceShow', params: {id: item.idInvoice} }"
              class="btn btn-default btn-sm"
            >{{$t('buttons.goToInvoice')}}</router-link>
          </div>
          <div class="btn-group mb-1 float-right">
              <router-link tag="button"
                v-if="prevRoute && prevRoute.name === 'EXCMTaskShow'"
                :to="{ path: prevRoute.path }"
                class="btn btn-sm btn-default">{{$t('buttons.backToTask')}}</router-link>
              <router-link tag="button" v-else-if="item" :to="{ name: 'EXSBDocumentList' }" class="btn btn-sm btn-default float-right">{{ $t('buttons.backToList') }}</router-link>
              <router-link tag="button"
                :to="{ name: 'EXSBOrderShow', params: { id: item.idOrder['@id'] }}"
                v-if="item.idOrder"
                class="btn btn-sm btn-default ">{{ $t('buttons.goToOrder') }}</router-link>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card>
            <div class="card-body">
              <b-row>
                <b-col>
                  <p v-if="item['documentType']"><b>{{$t('views.exsbdocument.show.documentType')}}:</b> {{ item['documentType'].name }}</p>
<!--                  <p v-if="item['protocolPeriodStart'] && item['protocolPeriodEnd']"><b>{{$t('views.exsbdocument.show.protocolPeriod')}}:</b> {{ item['protocolPeriodStart'] }} - {{ item['protocolPeriodEnd'] }}</p>-->
                  <p v-if="item['delivery']"><b>{{$t('views.exsbdocument.show.delivery')}}:</b> {{ item['delivery'].name }}</p>
                  <p><b>{{$t('views.exsbdocument.show.number')}}:</b> {{ item['number'] }}</p>
                  <p v-if="item['relatedDocumentNumber']"><b>{{$t('views.exsbdocument.show.relatedDocumentNumber')}}:</b> {{ item['relatedDocumentNumber'] }}</p>
                </b-col>
                <b-col>
                  <p><b>{{$t('views.exsbdocument.show.dateOfIssue')}}:</b> {{ item['dateOfIssue'] }}</p>
                  <p><b>{{$t('views.exsbdocument.show.placeOfIssue')}}:</b> {{ item['placeOfIssue'] }}</p>
                </b-col>
                <b-col>
                  <p><b>{{$t('views.exsbdocument.show.valueNetto')}}:</b> {{ item['valueNetto'] }}</p>
                  <p><b>{{$t('views.exsbdocument.show.valueBrutto')}}:</b> {{ item['valueBrutto'] }}</p>
                </b-col>
              </b-row>
              <b-row v-if="item['comments']">
                <b-col>
                  <p><b>{{$t('views.exsbdocument.show.comments')}}:</b> {{ item['comments'] }}</p>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <h6>{{$t('views.exsbdocument.show.receiverData')}}:</h6>
                  <p>
                    <b v-if="item['receiver']">{{$t('views.exsbdocument.show.receiver')}}:</b> <span class="ml-1">{{ item['receiver'] }} </span>
                    <b v-if="item['receiverNip']">{{$t('views.exsbdocument.show.receiverNip')}}:</b> <span class="ml-1">{{ item['receiverNip'] }}</span>
                    <b v-if="item['receiverStreet']" class="ml-3">{{$t('views.exsbdocument.show.receiverStreet')}}:</b> <span class="ml-1">{{ item['receiverStreet'] }}</span>
                    <b v-if="item['receiverCity']" class="ml-3">{{$t('views.exsbdocument.show.receiverCity')}}:</b> <span class="ml-1">{{ item['receiverCity'] }}</span>
                    <b v-if="item['receiverPostcode']" class="ml-3">{{$t('views.exsbdocument.show.receiverPostcode')}}:</b> <span class="ml-1">{{ item['receiverPostcode'] }}</span>
                  </p>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <h6>{{$t('views.exsbdocument.show.exhibitorData')}}:</h6>
                  <p>
                    <b v-if="item['exhibitor']">{{$t('views.exsbdocument.show.exhibitor')}}:</b> <span class="ml-1">{{ item['exhibitor'] }} </span>
                    <b v-if="item['exhibitorNip']">{{$t('views.exsbdocument.show.exhibitorNip')}}:</b> <span class="ml-1">{{ item['exhibitorNip'] }}</span>
                    <b v-if="item['exhibitorStreet']" class="ml-3">{{$t('views.exsbdocument.show.exhibitorStreet')}}:</b> <span class="ml-1">{{ item['exhibitorStreet'] }}</span>
                    <b v-if="item['exhibitorCity']" class="ml-3">{{$t('views.exsbdocument.show.exhibitorCity')}}:</b> <span class="ml-1">{{ item['exhibitorCity'] }}</span>
                    <b v-if="item['exhibitorPostcode']" class="ml-3">{{$t('views.exsbdocument.show.exhibitorPostcode')}}:</b> <span class="ml-1">{{ item['exhibitorPostcode'] }}</span>
                  </p>
                </b-col>
              </b-row>
              <b-row v-if="item.positions.length > 0">
                <b-col>
                  <b-row>
                    <b-col>
                      <h6>{{$t('views.exsbdocument.show.documentPositions')}}:</h6>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <table class="text-center border-table">
                        <tr>
                          <th>{{$t('views.exsbdocument.show.documentPosition.lp')}}</th>
                          <th>{{$t('views.exsbdocument.show.documentPosition.item')}}</th>
                          <th>{{$t('views.exsbdocument.show.documentPosition.quantity')}}</th>
                          <th>{{$t('views.exsbdocument.show.documentPosition.measure')}}</th>
                          <th>{{$t('views.exsbdocument.show.documentPosition.warehouse')}}</th>
                          <th v-if="getIdLink(item.documentType['@id']) == 6">{{$t('views.exsbdocument.show.documentPosition.newWarehouse')}}</th>
                          <th>{{$t('views.exsbdocument.show.documentPosition.discount')}}</th>
                          <th>{{$t('views.exsbdocument.show.documentPosition.pricePerUnitNetto')}}</th>
                          <th>{{$t('views.exsbdocument.show.documentPosition.vatRate')}}</th>
                          <th>{{$t('views.exsbdocument.show.documentPosition.pricePerUnitBrutto')}}</th>
                        </tr>
                        <tr v-for="(position, index) in item['positions']" v-bind:key="index">
                          <td>{{ index + 1 }}</td>
                          <td>{{ position.item.name }}</td>
                          <td>{{ position.quantity }}</td>
                          <td>{{ position.item.measure.name }}</td>
                          <td>{{ position.warehouse.name }} <span v-if="position.warehouseQuantity">({{ position.warehouseQuantity }})</span></td>
                          <td v-if="position.newWarehouse">{{ position.newWarehouse.name }} <span v-if="position.newWarehouseQuantity">({{ position.newWarehouseQuantity }})</span></td>
                          <td>{{ position.discount }}%</td>
                          <td>{{ position.pricePerUnitNetto }}</td>
                          <td>{{ position.vatRate.range }}</td>
                          <td>{{ position.pricePerUnitBrutto }}</td>
                        </tr>
                      </table>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </b-col>
    <GenerateInvoiceFromPostitionsModal v-if="item" :positions="item.positions"></GenerateInvoiceFromPostitionsModal>
  </b-row>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import getId from '@/utils/getIdFromLink'
import { checkPagePermission, checkPermission } from '@/utils/checkRoles.js'
import Loader from '../../../Layout/Loader'
import GenerateInvoiceFromPostitionsModal from '@/components/Dashboard/Views/BusinessBundle/exsbinvoice/modals/GenerateInvoiceFromPostitionsModal'

export default {
  components: {
    Loader,
    GenerateInvoiceFromPostitionsModal
  },

  computed: {
    ableToCreateInvoice () {
      return checkPermission('finances', 'EXSBInvoiceCreate') && !this.item.idInvoice
    },
    ableToViewInvoice () {
      return checkPermission('finances', 'EXSBInvoiceShow')
    },
    ...mapGetters({
      deleteError: 'exsbdocument/del/error',
      error: 'exsbdocument/show/error',
      isLoading: 'exsbdocument/show/isLoading',
      item: 'exsbdocument/show/retrieved'
    })
  },

  data () {
    return {
      prevRoute: null
    }
  },

  beforeRouteEnter (to, from, next) {
    next((vm) => {
      vm.prevRoute = from
    })
  },

  beforeDestroy () {
    this.reset()
  },

  beforeCreate () {
    checkPagePermission('warehouses', 'EXSBDocumentShow')
  },

  created () {
    this.retrieve(decodeURIComponent(this.$route.params.id))
  },

  watch: {
    item: function (itemUpdate) {
      itemUpdate['dateOfIssue'] = this.$moment(itemUpdate['dateOfIssue']).format('YYYY-MM-DD')
      itemUpdate['protocolPeriodStart'] = this.$moment(itemUpdate['protocolPeriodStart']).format('YYYY-MM-DD')
      itemUpdate['protocolPeriodEnd'] = this.$moment(itemUpdate['protocolPeriodEnd']).format('YYYY-MM-DD')
    }
  },

  methods: {
    generateInvoice () {
      this.toggleModal()
    },
    ...mapMutations({
      toggleModal: 'exsbinvoice/generateFromPositionsModal/toggleModal'
    }),
    ...mapActions({
      del: 'exsbdocument/del/del',
      reset: 'exsbdocument/show/reset',
      retrieve: 'exsbdocument/show/retrieve'
    }),

    deleteItem (item) {
      if (window.confirm('Are you sure you want to delete this item?')) {
        this.del(item).then(() => this.$router.push({ name: 'EXSBDocumentList' }))
      }
    },

    getIdLink (link) {
      return getId(link)
    }
  }
}
</script>
